import { render } from "./upload-salary-step3.vue?vue&type=template&id=29faa2ac&scoped=true&ts=true"
import script from "./upload-salary-step3.vue?vue&type=script&lang=ts"
export * from "./upload-salary-step3.vue?vue&type=script&lang=ts"

import "./upload-salary-step3.vue?vue&type=style&index=0&id=29faa2ac&lang=stylus&scoped=true"

import exportComponent from "/Users/rong.chen/data/zd/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29faa2ac"]])

export default __exports__